jQuery(document).ready(function ($) {
  // Month names for display
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  /**
   * Format month for display (e.g., "Jan, 2025")
   */
  function formatMonthDisplay(year, month) {
    return monthNames[month] + ", " + year;
  }

  /**
   * Format month for API (e.g., "2025-01")
   */
  function formatMonthForAPI(year, month) {
    var monthNum = parseInt(month) + 1;
    var monthStr = monthNum < 10 ? "0" + monthNum : monthNum;
    return year + "-" + monthStr;
  }

  /**
   * Parse display format back to year and month
   */
  function parseDisplayFormat(displayValue) {
    // Extract from "Jan, 2025" format
    var parts = displayValue.split(", ");
    if (parts.length === 2) {
      var monthName = parts[0];
      var year = parseInt(parts[1]);
      var month = monthNames.indexOf(monthName);
      if (month !== -1) {
        return { year: year, month: month };
      }
    }
    return null;
  }

  /**
   * Apply filters automatically to all charts
   * Applies filters whenever any filter changes, even if not all are filled
   */
  function applyFiltersAuto() {
    var startDate = $("#startMonth").attr("data-value") || null;
    var endDate = $("#endMonth").attr("data-value") || null;
    var wardName = $("#globalWardFilter").val() || null;

    // Only validate date order if both dates are present
    if (startDate && endDate && startDate > endDate) {
      alert("Start month must be before or equal to end month.");
      return;
    }

    // Dispatch custom event for charts to listen to
    // Pass null values if filters aren't set - charts can handle partial filters
    $(document).trigger("filtersChanged", {
      startDate: startDate,
      endDate: endDate,
      wardName: wardName,
    });
  }

  // Initialize month/year picker for both inputs
  function createMonthYearPicker(selector) {
    $(selector).datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      dateFormat: "yy-mm",
      yearRange: "-10:+1",
      onClose: function (dateText, inst) {
        // Get selected month and year
        var month = $(
          "#ui-datepicker-div .ui-datepicker-month :selected"
        ).val();
        var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();

        // Set the display value and data attribute
        if (month !== undefined && year !== undefined) {
          var monthIndex = parseInt(month);
          var displayValue = formatMonthDisplay(year, monthIndex);
          var apiValue = formatMonthForAPI(year, monthIndex);

          // Set display value in input
          $(this).val(displayValue);

          // Store API value in data attribute
          $(this).attr("data-value", apiValue);

          // Auto-apply filters when month picker closes
          applyFiltersAuto();
        }
      },
      beforeShow: function (input, inst) {
        // If there's already a data-value, use it
        var apiValue = $(this).attr("data-value");
        if (apiValue && apiValue.length > 0) {
          var parts = apiValue.split("-");
          if (parts.length === 2) {
            var year = parseInt(parts[0]);
            var month = parseInt(parts[1]) - 1;
            $(this).datepicker(
              "option",
              "defaultDate",
              new Date(year, month, 1)
            );
            $(this).datepicker("setDate", new Date(year, month, 1));
          }
        } else {
          // Try to parse display value
          var displayValue = $(this).val();
          var parsed = parseDisplayFormat(displayValue);
          if (parsed) {
            $(this).datepicker(
              "option",
              "defaultDate",
              new Date(parsed.year, parsed.month, 1)
            );
            $(this).datepicker("setDate", new Date(parsed.year, parsed.month, 1));
          }
        }

        // Add a small delay to ensure the datepicker is rendered
        setTimeout(function () {
          // Hide the calendar days
          $("#ui-datepicker-div .ui-datepicker-calendar").hide();

          // Position the datepicker
          $("#ui-datepicker-div").position({
            my: "center top",
            at: "center bottom",
            of: $(input),
          });
        }, 1);
      },
    });

    // Hide calendar on focus as well
    $(selector).focus(function () {
      setTimeout(function () {
        $(".ui-datepicker-calendar").hide();
      }, 1);
    });
  }

  // Initialize both month pickers
  createMonthYearPicker("#startMonth");
  createMonthYearPicker("#endMonth");

  // Auto-apply filters when ward filter changes
  $("#globalWardFilter").on("change", function () {
    applyFiltersAuto();
  });
});
